import axios from "axios";
import clientOptions from "./client_options";

const axiosClient = axios.create(clientOptions);

axiosClient.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 403) {
      console.log("Not Authenticated");
    }
    return Promise.reject(error);
  }
);

function install(Vue) {
  Vue.axios = axiosClient;
  window.axios = axiosClient;
  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return axiosClient;
      },
    },
    $axios: {
      get() {
        return axiosClient;
      },
    },
  });
}

export { install, axiosClient };
